import React from "react"
import PropTypes from "prop-types"
import {
  rendezVousRecapContainer,
  rendezVousTitle,
} from "./rendez-vous-part-7.module.scss"
import {
  RendezVousSubContainer,
  RendezVousTitle,
} from "../rendez-vous-styled.js"

export const RendezVousPart7 = ({ mail }) => {
  return (
    <RendezVousSubContainer className={rendezVousRecapContainer}>
      <RendezVousTitle className={rendezVousTitle}>
        Votre demande a bien été prise en compte !
      </RendezVousTitle>
      {mail && (
        <p>
          Vous recevrez un e-mail de confirmation à l&apos;adresse <b>{mail}</b>
          . Si vous ne recevez pas de confirmation, veuillez réessayer.
        </p>
      )}
    </RendezVousSubContainer>
  )
}

RendezVousPart7.propTypes = {
  mail: PropTypes.string,
}
